import React from "react";
import "./FieldHeader.scss";

interface IProps {
    name: string;
    description: string;
}

const FieldHeader = (props: IProps) => {
    return (
        <div className="fieldHeaderDiv">
            <h1>{props.name}</h1>
            <p>{props.description}</p>
        </div>
    );
};

export default FieldHeader;
